import * as React from 'react';
import { CallbackForm } from '../../../../components/CallbackDesktopWidget/CallbackForm';
import { CallbackFormWithRecommendations } from '../../../../components/CallbackDesktopWidget/CallbackFormWithRecommendations';
import { FailureContent } from '../../../../components/CallbackDesktopWidget/FailureContent';
import { SuccessContent } from '../../../../components/CallbackDesktopWidget/SuccessContent';
import { RECOMMENDATIONS_SUCCESS_MESSAGE } from '../../../../constants/messages';
import { useCallbackForm } from '../../../../hooks/useCallbackForm';
import { useCallbackState, EFormStatus } from '../../../../hooks/useCallbackState';
import { getSuccessCallbackMessage } from '../../../../utils/messages';
export var CallbackContentContainer = function CallbackContentContainer(_ref) {
  var agentPhone = _ref.agentPhone,
    defaultRecommendationsEnabled = _ref.defaultRecommendationsEnabled,
    newbuildingName = _ref.newbuildingName,
    onClose = _ref.onClose,
    onError = _ref.onError,
    onRequestCallback = _ref.onRequestCallback,
    onRecommendationsChange = _ref.onRecommendationsChange,
    onSuccess = _ref.onSuccess,
    privacyPolicyUrl = _ref.privacyPolicyUrl,
    recommendations = _ref.recommendations,
    recommendationTime = _ref.recommendationTime,
    timezoneOffset = _ref.timezoneOffset,
    userPhoneNumber = _ref.userPhoneNumber,
    workTime = _ref.workTime,
    isSMSDisclaimerEnabled = _ref.isSMSDisclaimerEnabled,
    callbackButtonText = _ref.callbackButtonText;
  var _useCallbackState = useCallbackState({
      onError: onError,
      onRequestCallback: onRequestCallback,
      onSuccess: onSuccess,
      privacyPolicyUrl: privacyPolicyUrl,
      timezoneOffset: timezoneOffset
    }),
    callbackDate = _useCallbackState.callbackDate,
    handleRequestCallback = _useCallbackState.handleRequestCallback,
    privacyPolicyLink = _useCallbackState.privacyPolicyLink,
    resetState = _useCallbackState.resetState,
    status = _useCallbackState.status,
    timezoneDiff = _useCallbackState.timezoneDiff;
  var _useCallbackForm = useCallbackForm({
      agentPhone: agentPhone,
      defaultRecommendationsEnabled: defaultRecommendationsEnabled,
      onRecommendationsChange: onRecommendationsChange,
      onRequestCallback: handleRequestCallback,
      recommendations: recommendations,
      recommendationTime: recommendationTime,
      timezoneDiff: timezoneDiff,
      userPhoneNumber: userPhoneNumber,
      workTime: workTime
    }),
    callTime = _useCallbackForm.callTime,
    errors = _useCallbackForm.errors,
    firstFieldRef = _useCallbackForm.firstFieldRef,
    handlePhoneChange = _useCallbackForm.handlePhoneChange,
    handleSubmit = _useCallbackForm.handleSubmit,
    handleTimeChange = _useCallbackForm.handleTimeChange,
    handleUserConfirmedChange = _useCallbackForm.handleUserConfirmedChange,
    handleWithRecommendationsChange = _useCallbackForm.handleWithRecommendationsChange,
    isSubmitDisabled = _useCallbackForm.isSubmitDisabled,
    isSubmitting = _useCallbackForm.isSubmitting,
    values = _useCallbackForm.values;
  var hasRecommendations = recommendations && recommendations.length > 0;
  switch (status) {
    case EFormStatus.Failure:
      return /*#__PURE__*/React.createElement(FailureContent, {
        onConfirm: resetState
      });
    case EFormStatus.Success:
      return hasRecommendations && values.withRecommendations ? /*#__PURE__*/React.createElement(SuccessContent, {
        additionalMessage: RECOMMENDATIONS_SUCCESS_MESSAGE,
        onConfirm: onClose,
        text: getSuccessCallbackMessage(callbackDate, timezoneDiff, newbuildingName || '')
      }) : /*#__PURE__*/React.createElement(SuccessContent, {
        onConfirm: onClose,
        text: getSuccessCallbackMessage(callbackDate, timezoneDiff)
      });
    default:
      return hasRecommendations ? /*#__PURE__*/React.createElement(CallbackFormWithRecommendations, {
        callTime: callTime,
        errors: errors,
        onSubmit: handleSubmit,
        onPhoneChange: handlePhoneChange,
        onTimeChange: handleTimeChange,
        onUserConfirm: handleUserConfirmedChange,
        onWithRecommendationsChange: handleWithRecommendationsChange,
        isSubmitting: isSubmitting,
        isSubmitDisabled: isSubmitDisabled,
        phoneRef: firstFieldRef,
        privacyPolicyUrl: privacyPolicyLink,
        recommendations: recommendations,
        values: values,
        isSMSDisclaimerEnabled: isSMSDisclaimerEnabled,
        callbackButtonText: callbackButtonText
      }) : /*#__PURE__*/React.createElement(CallbackForm, {
        callTime: callTime,
        errors: errors,
        onSubmit: handleSubmit,
        onPhoneChange: handlePhoneChange,
        onTimeChange: handleTimeChange,
        onUserConfirm: handleUserConfirmedChange,
        isSubmitting: isSubmitting,
        isSubmitDisabled: isSubmitDisabled,
        phoneRef: firstFieldRef,
        privacyPolicyUrl: privacyPolicyLink,
        values: values,
        isSMSDisclaimerEnabled: isSMSDisclaimerEnabled,
        callbackButtonText: callbackButtonText
      });
  }
};